const characterWalk = (duration, val, gait) => {
  val = val || 10
  gait = gait || 1000
  duration = duration / gait
  let result = []

  for (let i = 0; i < duration; i ++) {
    result.push({ value: '0' })
    result.push({value: val + 'px'})
  }

  result.push({value: '0'})

  return result
}

export {characterWalk}


// WEBPACK FOOTER //
// ./src/assets/js/utils/characterWalk.js